import { createFileRoute, Link } from "@tanstack/react-router";
import { LegalList, LegalPage, LegalSection } from "@/components/legal/LegalPage";

export const Route = createFileRoute("/cookies")({
  component: CookiesRoute,
  head: () => ({
    meta: [
      { title: "Política de cookies — Sift Trip" },
      { name: "description", content: "Cómo SiftTrip usa cookies y tecnologías similares." },
    ],
  }),
});

function CookiesRoute() {
  return (
    <LegalPage title="Politica de cookies" eyebrow="Preferencias y medicion">
      <LegalSection title="1. Que son las cookies">
        <p>
          Las cookies y tecnologias similares permiten reconocer un navegador,
          recordar preferencias, mantener sesiones, medir uso, mejorar seguridad
          y entender el rendimiento de la plataforma.
        </p>
      </LegalSection>

      <LegalSection title="2. Que usamos hoy">
        <LegalList
          items={[
            "Necesarias: almacenamiento local (localStorage) que usa Supabase para mantener la sesion iniciada del usuario, y para recordar preferencias basicas de idioma y moneda.",
            "Analiticas: usamos PostHog para entender que funciones se usan, tiempos de carga, errores y conversiones agregadas. Esto incluye un identificador anonimo de visitante guardado en el navegador, que no esta vinculado al nombre o correo del usuario salvo que haya iniciado sesion.",
            "Preferencias: idioma, moneda, filtros, viajeros u otras configuraciones elegidas por el usuario.",
            "Medicion de enlaces a proveedores: cuando el usuario continua hacia Viator, GuruWalk u otro proveedor externo, podemos registrar esa salida para medir que resultados generan clics. Esto no le da a SiftTrip acceso a lo que el usuario haga en el sitio del proveedor.",
          ]}
        />
        <p>
          Actualmente no usamos cookies de publicidad propia ni vendemos datos
          de navegacion a redes publicitarias.
        </p>
      </LegalSection>

      <LegalSection title="3. Terceros">
        <p>
          Algunos proveedores de autenticacion (Supabase, Google), analitica
          (PostHog), monitoreo, infraestructura o los proveedores externos a los
          que el usuario continua (Viator, GuruWalk) pueden usar sus propias
          cookies o tecnologias equivalentes. Cuando el usuario navega a un
          proveedor externo, aplican las politicas de ese proveedor.
        </p>
      </LegalSection>

      <LegalSection title="4. Control del usuario">
        <p>
          El usuario puede administrar cookies y almacenamiento local desde la
          configuracion de su navegador. Bloquear el almacenamiento necesario
          puede afectar la autenticacion, las preferencias o el funcionamiento
          basico de la plataforma. Hoy no mostramos un banner de consentimiento
          de cookies; cuando implementemos un panel de consentimiento granular,
          esta politica se actualizara.
        </p>
      </LegalSection>

      <LegalSection title="5. Relacion con privacidad">
        <p>
          Esta politica complementa la{" "}
          <Link to="/privacidad" className="font-semibold text-[#E8194B]">
            politica de privacidad
          </Link>
          . Si una cookie permite identificar directa o indirectamente a una
          persona, tratamos esa informacion como dato personal cuando la ley lo
          exija. Para preguntas sobre esta politica, escribe a{" "}
          <a href="mailto:contact@siftrip.com" className="font-semibold text-[#E8194B]">
            contact@siftrip.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
}
